import React, {Component} from 'react';
import $ from 'jquery';
import {Link} from 'react-router-dom';
import Meta from '../model/Meta';

class AboutUs extends Component {

	componentDidMount(){
		$('html, body').animate({scrollTop: 0}, 300);
	}

	render(){

		const meta = {
			title: "About Contracts.ph",
			description: "Contracts.ph helps you create, customize and print your legal documents in no time"
		}

		return (
			<div className="page page-inner not-found pb-5">
				<Meta {...meta}/>
				<div className="about-us-banner"></div>
				<div className="container-fluid">
					<div className="container p-0">
						<h1 className="page-title">Creating legal documents made easy.</h1>
						<div className="page-content">
							<p>Need to create a legal contract but don’t know how to start? Contracts.ph helps you create, customize and print your legal documents in no time.</p>
							<p>With the help of lawyers and legal professionals, we have prepared set of questions to help you customize your contracts just the way you need it. After answering the queries, you can download and print the document for you to sign and execute. Now that’s easy and fast premium legal protection right at your fingertips.</p>
						</div>
					</div>
				</div>
				<div className="my-4 text-center">
					<Link to="/contracts" className="btn btn-lightblue">Browse our legal documents</Link>
				</div>
			</div>
		);
	}
}

export default AboutUs;


// WEBPACK FOOTER //
// ./src/pages/AboutUs.js